<div class="top">
  <p class="top-word">
    <!-- 房源审核失败，请前往爱彼迎修改房源信息后重新提交审核 -->
    {{ "house.check_airbnb_house_failed" | translate }}
  </p>
</div>
<div class="container">
  <div class="info">
    <div class="left">
      <img [src]="detail?.url" />
    </div>
    <div class="right">
      <p class="title">{{ detail?.title || "无" }}</p>
      <div class="third-party">
        {{ "word.channel_0" | translate }}-{{ detail?.account_id }}
      </div>
    </div>
  </div>
  <div class="fail-reason">
    <p class="title">
      <!-- 失败原因: -->
      {{ "word.fail_reason" | translate }}
    </p>
    <div class="text" *ngFor="let item of detail?.fail_reason">
      <p>· {{ item?.reason }}</p>
      <div class="picture" *ngIf="item?.urls">
        <div
          *ngFor="let picture of item.urls; index as i"
          [ngClass]="{ 'normal-img': i % 4 !== 3 }"
          style="padding-top: 15px;"
        >
          <img [src]="picture" />
        </div>
      </div>
    </div>
    <div class="check-rules" (click)="checkRules()">
      <!-- 查看具体规则 -->
      {{ "channel.airbnb_check_rules" | translate }}
    </div>
  </div>
</div>
<div class="footer">
  <div class="button">
    <button nz-button nzType="primary" (click)="retry()">
      <!-- 已修改，重新审核 -->
      {{ "house.airbnb_modified_recheck" | translate }}
    </button>
  </div>
  <div class="button">
    <button nz-button nzType="default" (click)="toFailHouses()">
      <!-- 审核失败房源 -->
      {{ "house.check_failed_channel_house" | translate }}
    </button>
  </div>
</div>
